import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './spinner.css';

function Spinner(props) {
  const { autoSize } = props;

  const cls = classNames([
    styles.preloaderWrapper,
    styles.active,
    autoSize ? styles.preloaderWrapperAuto : styles.preloaderWrapperMd,
  ]);

  return (
    <div className={cls}>
      <div className={styles.spinnerLayer}>
        <div className={`${styles.circleClipper} ${styles.left}`}>
          <div className={styles.circle} />
        </div>
        <div className={styles.gapPatch}>
          <div className={styles.circle} />
        </div>
        <div className={`${styles.circleClipper} ${styles.right}`}>
          <div className={styles.circle} />
        </div>
      </div>
    </div>
  );
}

Spinner.propTypes = {
  autoSize: PropTypes.bool,
};
Spinner.defaultProps = {
  autoSize: false,
};

export default Spinner;
